/* eslint-disable prettier/prettier */
import { Box } from "@twilio-paste/core/box";
import { useSelector } from "react-redux";
import { useEffect, useRef } from "react";


import { MessagingCanvasPhase } from "./MessagingCanvasPhase";
import { AppState, EngagementPhase } from "../store/definitions";
import { PreEngagementFormPhase } from "./PreEngagementFormPhase";
import { LoadingPhase } from "./LoadingPhase";
import { EntryPoint } from "./EntryPoint";
import { innerContainerStyles, outerContainerStyles } from "./styles/RootContainer.styles";



const getPhaseComponent = (phase: EngagementPhase) => {
    
     switch (phase) {
         case EngagementPhase.Loading:
              return <LoadingPhase />;
          case EngagementPhase.UserEnding:    
          case EngagementPhase.MessagingCanvas:
             return <MessagingCanvasPhase />;
          case EngagementPhase.PreEngagementForm:
         default:
             return <PreEngagementFormPhase />;
     }
    
    
};

// Notifie le parent (si le widget tourne dans une iframe) des changements de taille
const notifyParentResize = (expanded: boolean) => {
    if (window.parent === window) return;
    window.parent.postMessage(
        {
            type: "TWILIO_WEBCHAT_RESIZE",
            expanded
        },
        "*"
    );
};

export function RootContainer() {
    const { currentPhase, expanded } = useSelector(({ session }: AppState) => ({
        currentPhase: session.currentPhase,
        expanded: session.expanded
    }));

    // Synchronise la taille de l'iframe avec l'état ouvert/fermé du chat
    const prevExpanded = useRef<boolean | undefined>(undefined);
    useEffect(() => {
        if (prevExpanded.current !== expanded) {
            prevExpanded.current = expanded;
            notifyParentResize(expanded);
        }
    }, [expanded]);

    return (
        <Box>
            <Box {...outerContainerStyles}>
                {expanded && (
                    <Box data-test="root-container" {...innerContainerStyles}>
                        {getPhaseComponent(currentPhase)}
                    </Box>
                )}
                <EntryPoint />
            </Box>
        </Box>
    );
}
